module.exports = __webpack_public_path__ + "media/src/images/icons/phone-0faaf2457fea93f3b3409bcf08e84f9c.svg";